import naja from 'naja';

class PersonStockSearch {
    private searchInput: HTMLInputElement;
    private productsContainer: HTMLElement;
    private noResultsElement: HTMLElement;
    private productItems: NodeListOf<HTMLElement> = document.querySelectorAll('.person-order-product__item');

    constructor() {
        this.searchInput = document.getElementById('stock-search') as HTMLInputElement;
        this.productsContainer = document.getElementById('stock-products') as HTMLElement;
        this.noResultsElement = document.getElementById('no-results') as HTMLElement;

        if (!this.searchInput || !this.productsContainer) {
            return;
        }

        this.productItems = this.productsContainer.querySelectorAll('.person-order-product__item');

        this.initializeEvents();
        this.initializeQuantityControls();
    }

    private initializeEvents(): void {
        if (this.searchInput) {
            this.searchInput.addEventListener('input', () => this.performSearch());
            this.searchInput.addEventListener('keyup', () => this.performSearch());
        }
    }

    private initializeQuantityControls(): void {
        // Initialize quantity controls for each product
        const quantityControls = document.querySelectorAll('.quantity-input');

        quantityControls.forEach((control) => {
            const minusBtn = control.querySelector('.quantity-minus') as HTMLButtonElement;
            const plusBtn = control.querySelector('.quantity-plus') as HTMLButtonElement;
            const input = control.querySelector('.quantity-field') as HTMLInputElement;
            const packSize = parseInt(input.getAttribute('min') || '1');

            if (minusBtn && plusBtn && input) {
                minusBtn.addEventListener('click', () => {
                    this.changeQuantity(input, -10, packSize);
                });

                plusBtn.addEventListener('click', () => {
                    this.changeQuantity(input, 10, packSize);
                });

                // Add validation for manual input
                input.addEventListener('blur', () => {
                    this.validateQuantityInput(input, packSize);
                });

                input.addEventListener('input', () => {
                    this.validateQuantityInput(input, packSize);
                });
            }
        });

        // Initialize reorder buttons
        const reorderButtons = document.querySelectorAll('.reorder-btn');
        reorderButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const productId = button.getAttribute('data-product-id');
                if (productId) {
                    this.reorderWithQuantity(parseInt(productId));
                }
            });
        });
    }

    private changeQuantity(input: HTMLInputElement, change: number, packSize: number): void {
        const currentValue = parseInt(input.value) || packSize;
        const newValue = Math.max(packSize, currentValue + change);
        input.value = newValue.toString();
    }

    private validateQuantityInput(input: HTMLInputElement, packSize: number): void {
        const value = parseInt(input.value) || packSize;
        if (value < packSize) {
            input.value = packSize.toString();
        }
    }

    private reorderWithQuantity(productId: number): void {
        const quantityInput = document.getElementById(`quantity-${productId}`) as HTMLInputElement;
        const quantity = parseInt(quantityInput.value) || 1;
        const packSize = parseInt(quantityInput.getAttribute('min') || '1');

        if (quantity < packSize) {
            alert(`Množství musí být alespoň ${packSize}.`);
            return;
        }

        // Get the base URL from the section element
        const section = document.querySelector('.person-order') as HTMLElement;
        let baseUrl = section?.getAttribute('data-reorder-url') || '';

        // Replace placeholder values with actual values - try multiple formats
        baseUrl = baseUrl.replace(/productId[=%]0/g, `productId=${productId}`);
        baseUrl = baseUrl.replace(/quantity[=%]1/g, `quantity=${quantity}`);

        // If quantity parameter wasn't in the original URL, add it
        if (!baseUrl.includes('quantity=')) {
            const separator = baseUrl.includes('?') ? '&' : '?';
            baseUrl += `${separator}quantity=${quantity}`;
        }

        naja.makeRequest('GET', baseUrl, null, {
            history: false,
        });
    }

    private performSearch(): void {
        const searchTerm = this.searchInput.value.toLowerCase().trim();
        let visibleCount = 0;

        this.productItems.forEach((item) => {
            const productTitle = item.getAttribute('data-product-title');
            const productCode = item.getAttribute('data-product-code');
            const parentTitle = item.getAttribute('data-parent-title');

            const titleMatch = productTitle && productTitle.toLowerCase().includes(searchTerm);
            const codeMatch = productCode && productCode.toLowerCase().includes(searchTerm);
            const parentMatch = parentTitle && parentTitle.toLowerCase().includes(searchTerm);

            if (searchTerm === '' || titleMatch || codeMatch || parentMatch) {
                item.style.display = 'block';
                visibleCount++;
            } else {
                item.style.display = 'none';
            }
        });

        // Show/hide no results message
        if (this.noResultsElement) {
            if (visibleCount === 0 && searchTerm !== '') {
                this.noResultsElement.style.display = 'block';
            } else {
                this.noResultsElement.style.display = 'none';
            }
        }
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('stock-search')) {
        new PersonStockSearch();
    }
});

export default PersonStockSearch;
